import { useMemo } from 'react';
import getMeta from '@jira/platform__utils-get-meta/src/utils/get-meta/index.tsx';

export const useSiteTitle = (): {
	shouldShow: boolean;
	value: string | null;
} =>
	useMemo(
		() => ({
			shouldShow: getMeta('ajs-lf-top-adg3-shouldshowtitle') === 'true',
			value: getMeta('ajs-app-title'),
		}),
		[],
	);
